/**
 * <DailyPlanHeaderButton /> — small chip in the AppShell header that
 * opens the workspace <DailyPlanDialog />.
 *
 * Everyone can open it (backend returns only their own row for
 * non-managers), so no permission gate on the button itself.
 */
import { useState, useEffect } from "react";
import { CalendarRange } from "lucide-react";
import DailyPlanDialog from "@/components/timesheet/DailyPlanDialog";

export default function DailyPlanHeaderButton() {
  const [open, setOpen] = useState(false);
  // R127 · Feb 2026 — Listen for a global open event so the mobile
  // overflow menu can trigger the same dialog without duplicating
  // rendering logic.
  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener("open-daily-plan", onOpen);
    return () => window.removeEventListener("open-daily-plan", onOpen);
  }, []);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 border border-border hover:bg-muted transition"
        title="Daily plan — visualise today's time allocation across the workspace"
        data-testid="header-daily-plan-btn"
      >
        <CalendarRange className="w-3.5 h-3.5 text-primary" />
        <span className="hidden lg:inline">Daily plan</span>
      </button>
      {open && <DailyPlanDialog open={open} onClose={() => setOpen(false)} />}
    </>
  );
}
